<p>pin-manager works!</p>
